import { useLocalStorage } from '@vueuse/core'

export interface ConnectionSetupStatus {
  permanently_skipped: boolean
  skip_until?: string
  last_updated: string
}

const STORAGE_KEY = 'connection_setup_status'

function getDefaultProgress(): ConnectionSetupStatus {
  return {
    permanently_skipped: false,
    skip_until: undefined,
    last_updated: new Date().toISOString(),
  }
}

/**
 * Composable for managing connection setup status using useLocalStorage
 * Use this in Vue components or Pinia stores.
 *
 * The returned ref automatically syncs with localStorage - just read/write to .value
 */
export function useConnectionSetupStatus() {
  const connectionSetupStatus = useLocalStorage<ConnectionSetupStatus>(
    STORAGE_KEY,
    getDefaultProgress()
  )

  return {
    connectionSetupStatus,
  }
}
